import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import { Modal } from 'react-bootstrap';

export default function GenerateSourcedLink({ websiteUrl, sources }) {
  const [show, setShow] = useState(false);

  const openModal = () => setShow(true);
  const closeModal = () => setShow(false);

  return (
    <React.Fragment>
      <button className="btn btn-sm btn-primary mb-3 w-100" onClick={openModal}>
        <FontAwesomeIcon className="mr-3" icon={faLink}/>
        Generate Link
      </button>
      <GenerateLinkModal
        closeModal={closeModal}
        show={show}
        sources={sources}
        websiteUrl={websiteUrl}
      />
    </React.Fragment>
  );
}

function GenerateLinkModal({ closeModal, websiteUrl, show, sources }) {
  const [link, setLink] = useState('Where will this link be shared?');
  const [notification, setNotification] = useState();

  const addUrlSource = (baseUrl, source) => {
    const url = new URL(baseUrl);
    url.searchParams.append('b_utm_source', source);

    return url.toString();
  };

  const updateLink = (source) => {
    const updatedLink = addUrlSource(websiteUrl, source);
    setLink(updatedLink);
    navigator.clipboard.writeText(updatedLink);
    setNotification('Link copied to clipboard!');
    setTimeout(() => {
      setNotification(null);
    }, 3000);
  };

  const selected = source => link.includes(`b_utm_source=${source}`);

  return (
    <Modal className="generate-link-modal" show={show} onHide={() => closeModal()}>
      <Modal.Header closeButton>
        <Modal.Title>Generate Link</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {notification && (
          <div className="alert alert-success" role="alert">
            {notification}
          </div>
        )}
        {link}
        <div>
          {sources.map(source => (
            <button
              className={'btn btn-sm mt-3 mr-3 ' + (selected(source) ? 'btn-primary' : 'btn-dark')}
              key={source}
              onClick={() => updateLink(source)}
            >
              {source.charAt(0).toUpperCase() + source.slice(1)}
            </button>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
}

GenerateSourcedLink.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.string).isRequired,
  websiteUrl: PropTypes.string.isRequired
};

GenerateLinkModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  sources: PropTypes.arrayOf(PropTypes.string).isRequired,
  websiteUrl: PropTypes.string.isRequired
};
